/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LifeInputs */

const en_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Life`)
};

const es_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vida`)
};

const fr_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vie`)
};

const de_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Life`)
};

const ja_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライフコーチング`)
};

const zh_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生活指导`)
};

const ar_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حياة`)
};

const id_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehidupan`)
};

const it_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Life Coaching`)
};

const ru_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лайф`)
};

const pt_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Life Coaching`)
};

const ko_val_life = /** @type {(inputs: Val_LifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이프 코칭`)
};

/**
* | output |
* | --- |
* | "Life" |
*
* @param {Val_LifeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_life = /** @type {((inputs?: Val_LifeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LifeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_life(inputs)
	if (locale === "es") return es_val_life(inputs)
	if (locale === "fr") return fr_val_life(inputs)
	if (locale === "de") return de_val_life(inputs)
	if (locale === "ja") return ja_val_life(inputs)
	if (locale === "zh") return zh_val_life(inputs)
	if (locale === "ar") return ar_val_life(inputs)
	if (locale === "id") return id_val_life(inputs)
	if (locale === "it") return it_val_life(inputs)
	if (locale === "ru") return ru_val_life(inputs)
	if (locale === "pt") return pt_val_life(inputs)
	return ko_val_life(inputs)
});